import {
    SupportedCountries,
    countriesList,
    type SupportedCountry,
} from '@archipro-website/localisation';

function isSupportedCountry(code: string): code is SupportedCountry {
    return SupportedCountries.includes(code as SupportedCountry);
}

/**
 * Business Manager URL for a company the member can switch into.
 *
 * Other-market companies must be opened on their own domain — a relative
 * `/business/{segment}` on the current site 404s or shows the wrong profile.
 * When GraphQL does not supply PrimaryDomain (TeamMembers fallback), the
 * market host is taken from the company's country code.
 */
export function professionalBusinessHref(
    urlSegment: string,
    options: {
        country?: string | null;
        primaryDomain?: string | null;
        currentCountryCode?: string;
        suffix?: string;
    } = {},
): string {
    const path = `/business/${urlSegment}${options.suffix ?? ''}`;
    const current = options.currentCountryCode?.toUpperCase();
    const country = options.country?.toUpperCase();
    const domainFromField = options.primaryDomain?.replace(/^https?:\/\//, '');
    const domainFromCountry =
        country && isSupportedCountry(country)
            ? countriesList[country].domain
            : '';
    const domain = domainFromField || domainFromCountry;

    if (domain && country && current && country !== current) {
        return `https://${domain}${path}`;
    }

    return path;
}
